import { useTranslation } from 'react-i18next';

const Hero = ({ config, ruta }) => {

    const { t } = useTranslation();

    return (
        <div className="c-rw-header-img">
            <figure className="c-rw-header-img_back">
                {/*<img loading="lazy" src="https://pro-static.h10hotels.com/gallery/H10RW_Cabecera_HazteSocio.webp" alt="" />*/}
                <img loading="lazy" src="/images/web/valesuites/atarceder_alta_socio.png" alt="" />
            </figure>
            <div className="container">
                <figure>
                    {
                        config.logo !== "" ?
                            <img loading="lazy" className="logo" alt="Logo" title="Logo" src={ruta + "/web/logo/web/" + config.logo} />
                            :
                            config.logo_fiscal != "" ?
                                <img loading="lazy" className="logo" alt="Logo" title="Logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                :
                                <img loading="lazy" className="logo" alt="Logo BedLoop" title="Logo BedLoop" src="https://www.bedloop.com/imatges/logo.webp" />
                    }
                </figure>
                <p className="c-rw-header-img_title">{t("HAZTE SOCIO")}</p>
                <p>{t("Únete a nuestro programa de fidelización y empieza a disfrutar de ventajas exclusivas.")}</p>
            </div>
        </div>
    );
}
export default Hero;
